"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SingleDatePicker = void 0;

var _react = _interopRequireWildcard(require("react"));

var _DateInput = require("../../input/DateInput");

var _Calendar = require("../../calendar/Calendar");

var _TextField = require("../../../TextField");

var _react2 = _interopRequireDefault(require("@mdi/react"));

var _js = require("@mdi/js");

var _styled = _interopRequireWildcard(require("../../../../styled"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var PickerContainer = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n\n  input {\n    color: ", ";\n    transition: color 300ms;\n  }\n\n  fieldset {\n    border-color: ", ";\n    transition: border-color 300ms;\n  }\n"])), function (_ref) {
  var hasError = _ref.hasError,
      theme = _ref.theme;
  return hasError ? theme.danger : undefined;
}, function (_ref2) {
  var hasError = _ref2.hasError,
      theme = _ref2.theme;
  return hasError ? theme.danger : undefined;
});

var InputContainer = (0, _styled["default"])(_TextField.Container)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([""])));

var CalendarContainer = _styled["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: ", ";\n  opacity: ", ";\n  transition: opacity 300ms, top 300ms,\n    z-index 0ms ease ", ";\n  z-index: ", ";\n  pointer-events: ", ";\n"])), function (_ref3) {
  var isFocused = _ref3.isFocused;
  return isFocused ? 'calc(100% + 0.5rem)' : 'calc(100% - 0.5rem)';
}, function (_ref4) {
  var isFocused = _ref4.isFocused;
  return isFocused ? 1 : 0;
}, function (_ref5) {
  var isFocused = _ref5.isFocused;
  return isFocused ? '0ms' : '300ms';
}, function (_ref6) {
  var isFocused = _ref6.isFocused;
  return isFocused ? 2 : -1;
}, function (_ref7) {
  var isFocused = _ref7.isFocused;
  return isFocused ? 'auto' : 'none';
});

var PickerHelp = (0, _styled["default"])(_TextField.Help)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref8) {
  var theme = _ref8.theme,
      hasError = _ref8.hasError;
  return hasError ? theme.danger : undefined;
});
var VERBOSE_ERRORS = {
  min: 'Date is below minimum date',
  max: 'Date is above maximum date'
};
/**
 * An expansion which combines both the DateInput and Calendar components for
 * a better UX.
 */

var SingleDatePicker = function SingleDatePicker(_ref9) {
  var value = _ref9.value,
      label = _ref9.label,
      help = _ref9.help,
      min = _ref9.min,
      max = _ref9.max,
      _ref9$placeholderChar = _ref9.placeholderCharacter,
      placeholderCharacter = _ref9$placeholderChar === void 0 ? ' ' : _ref9$placeholderChar,
      onChange = _ref9.onChange,
      onFocus = _ref9.onFocus,
      onBlur = _ref9.onBlur;
  var theme = (0, _styled.useTheme)();
  var labelRef = (0, _react.useRef)(null);
  var containerRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)('0'),
      _useState2 = _slicedToArray(_useState, 2),
      legendWidth = _useState2[0],
      setLegendWidth = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isFocused = _useState4[0],
      setIsFocused = _useState4[1];

  var _useState5 = (0, _react.useState)(value || null),
      _useState6 = _slicedToArray(_useState5, 2),
      localValue = _useState6[0],
      setLocalValue = _useState6[1];

  var _useState7 = (0, _react.useState)(value || null),
      _useState8 = _slicedToArray(_useState7, 2),
      localCalenderDisplay = _useState8[0],
      setLocalCalendarDisplay = _useState8[1];

  var _useState9 = (0, _react.useState)(null),
      _useState10 = _slicedToArray(_useState9, 2),
      localError = _useState10[0],
      setLocalError = _useState10[1];

  (0, _react.useEffect)(function () {
    if (!(localValue !== null && localValue !== void 0 && localValue.isEqualTo(value))) {
      setLocalValue(value || null);
    }
  }, [value, localValue]);
  (0, _react.useEffect)(function () {
    if (label) {
      (labelRef === null || labelRef === void 0 ? void 0 : labelRef.current) && setLegendWidth("calc(".concat(labelRef.current.offsetWidth * 0.75, "px + 0.5em)"));
    } else {
      setLegendWidth('0');
    }
  }, [label]);

  var handleOutsideClick = function handleOutsideClick(event) {
    var _containerRef$current;

    if (!(containerRef !== null && containerRef !== void 0 && (_containerRef$current = containerRef.current) !== null && _containerRef$current !== void 0 && _containerRef$current.contains(event.target))) {
      setIsFocused(false);
    }
  };

  (0, _react.useEffect)(function () {
    document.addEventListener('mousedown', handleOutsideClick);
    return function () {
      return document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);
  (0, _react.useEffect)(function () {
    isFocused ? onFocus && onFocus() : onBlur && onBlur();
  }, [isFocused, onFocus, onBlur]);

  var toggleFocus = function toggleFocus() {
    return setIsFocused(!isFocused);
  };

  var inputOnChange = function inputOnChange(dateParts) {
    setLocalValue(dateParts);
    setLocalCalendarDisplay(dateParts);
    if (dateParts !== null && dateParts !== void 0 && dateParts.isFullDate()) onChange && onChange(dateParts);
  };

  var inputOnFocus = function inputOnFocus() {
    setIsFocused(true);
  };

  var inputOnError = function inputOnError(errorType, dateParts) {
    setLocalCalendarDisplay(dateParts || null);
    setLocalError(errorType ? VERBOSE_ERRORS[errorType] : null);
  };

  var calendarOnChange = function calendarOnChange(dateParts) {
    onChange && onChange(dateParts[dateParts.length - 1] || null);
  };

  var calendarValues = (0, _react.useMemo)(function () {
    return localValue ? [localValue] : null;
  }, [localValue]);
  return /*#__PURE__*/_react["default"].createElement(PickerContainer, {
    ref: containerRef,
    hasError: !!localError
  }, /*#__PURE__*/_react["default"].createElement(InputContainer, null, /*#__PURE__*/_react["default"].createElement(_TextField.Wrapper, {
    hasLabel: !!label
  }, /*#__PURE__*/_react["default"].createElement(_TextField.Label, {
    focused: isFocused,
    hasValue: !!value,
    shrinked: true,
    ref: labelRef
  }, label), /*#__PURE__*/_react["default"].createElement(_TextField.InputWrapper, null, /*#__PURE__*/_react["default"].createElement(_DateInput.DateInput, {
    value: localValue,
    min: min,
    max: max,
    onChange: inputOnChange,
    onFocus: inputOnFocus,
    onError: inputOnError,
    placeholderCharacter: placeholderCharacter
  }), /*#__PURE__*/_react["default"].createElement(_TextField.Adornment, {
    side: "right",
    onClick: toggleFocus
  }, /*#__PURE__*/_react["default"].createElement(_react2["default"], {
    path: _js.mdiCalendar,
    size: 0.875,
    color: localError ? theme.danger : theme.foreground
  }))), /*#__PURE__*/_react["default"].createElement(_TextField.Fieldset, {
    focused: isFocused,
    style: {
      paddingLeft: '0.6em'
    },
    hasValue: !!value
  }, /*#__PURE__*/_react["default"].createElement(_TextField.Legend, {
    style: {
      width: legendWidth
    }
  }, "\u200B"))), localError || help ? /*#__PURE__*/_react["default"].createElement(PickerHelp, {
    hasError: !!localError
  }, localError || help) : null), /*#__PURE__*/_react["default"].createElement(CalendarContainer, {
    isFocused: isFocused
  }, /*#__PURE__*/_react["default"].createElement(_Calendar.Calendar, {
    value: calendarValues,
    min: min,
    max: max,
    display: localCalenderDisplay,
    onChange: calendarOnChange
  })));
};

exports.SingleDatePicker = SingleDatePicker;